import { SuccessCode } from '../models/success.model';
import { ErrorCode } from '../models/errors.model';
import { Alert } from '@proximus/ng-common-components';
import { TranslationService } from '@proximus/ng-common';
import { Injectable } from '@angular/core';

@Injectable()
export class AlertsUtilService {
  constructor(private translationService: TranslationService) {}

  getAlertFor(
    type: 'error' | 'info' | 'success' | 'warning',
    scrollTo: boolean,
    description: string,
    code?: SuccessCode | ErrorCode,
    title?: string,
  ): Alert {
    return {
      id: code ? code : undefined,
      scrollTo,
      title: title
        ? this.translationService.getTranslatedValueFor(title)
        : undefined,
      description: this.translationService.getTranslatedValueFor(description),
      type,
    };
  }
}
